var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59244 7.2L7.24494 9.06432C7.3909 9.48128 7.84728 9.70104 8.26426 9.55512C8.6813 9.40912 8.90106 8.95272 8.75514 8.53568L6.08725 0.913264C5.8958 0.366264 5.37956 0 4.80002 0C4.22049 0 3.70425 0.366263 3.51279 0.913264L0.844936 8.53568C0.698978 8.95272 0.91872 9.40912 1.33574 9.55512C1.75277 9.70104 2.20915 9.48128 2.35511 9.06432L3.00761 7.2H6.59244ZM6.03244 5.6L4.80002 2.07882L3.56761 5.6H6.03244Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4001 4C12.8869 4 13.3447 4.12425 13.7435 4.34276C13.8881 4.13556 14.1283 4 14.4001 4C14.8419 4 15.2001 4.35818 15.2001 4.8V8.8C15.2001 9.24184 14.8419 9.6 14.4001 9.6C14.1283 9.6 13.8881 9.46448 13.7435 9.25728C13.3447 9.47576 12.8869 9.6 12.4001 9.6C10.8537 9.6 9.6001 8.3464 9.6001 6.8C9.6001 5.2536 10.8537 4 12.4001 4ZM12.4001 8C13.0628 8 13.6001 7.46274 13.6001 6.8C13.6001 6.13726 13.0628 5.6 12.4001 5.6C11.7374 5.6 11.2001 6.13726 11.2001 6.8C11.2001 7.46274 11.7374 8 12.4001 8Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60029 11.2002C1.15846 11.2002 0.800293 11.5584 0.800293 12.0002C0.800293 12.442 1.15846 12.8002 1.60029 12.8002H14.4003C14.8421 12.8002 15.2003 12.442 15.2003 12.0002C15.2003 11.5584 14.8421 11.2002 14.4003 11.2002H1.60029Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60029 14.4001C1.15846 14.4001 0.800293 14.7583 0.800293 15.2001C0.800293 15.642 1.15846 16.0001 1.60029 16.0001H11.2003C11.6421 16.0001 12.0003 15.642 12.0003 15.2001C12.0003 14.7583 11.6421 14.4001 11.2003 14.4001H1.60029Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.996d565f1fac687eed5e319871fba4bc.svg";
export { ForwardRef as ReactComponent };